import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import Prompt from '../../widgets/Prompt';
import SkillsProgramSetupSearch from '../program/SkillsProgramSetupSearch';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";

export const skillsProgrammeHeadCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme Code' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Skills Programme Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Skills Programme Registration End Date' },
    { id: 'AssessorAssessmentEndDate', numeric: false, disablePadding: true, label: 'Assessor Assessment End Date' }
];

const toolbarRef = React.createRef();
const utils = new ViewUtils();

class AssessorSkillsProgrammeSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                SkillsProgrammeCode: "",
                SkillsProgrammeTitle: "",
                AssessorID: this.props.location.state.AssessorID
            },

            linkDialogOpen: false,
            selectedSkillsProgramme: null,
            propmtOpen: false,
            promptTitle: "Unlink Skills Programme From Assessor",
            promptContent: "Are you sure you want to unlink this skills programme from the assessor?",
            unlinkMessage: "",
            unlinkMessageStyle: "",
            searchParameters: [{Name: "AssessorID", Value: this.props.location.state.AssessorID}]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'link', label: 'Link Skills Programmes', tooltip: 'link the selected skills programmes to the assessor' },
                        { id: 'unlink', label: 'Unlink Skills Programme', tooltip: 'Un-link the selected skills programmes from the assessor', disabled: utils.isNull(this.state.selectedSkillsProgramme) }
                    ]
                }
            ]
        };

    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/assessor',
                state: { selection: this.props.location.state.AssessorID }
            });
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, unlinkMessage: "" })
        }
        else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    unlinkUnitstandard(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedSkillsProgramme}&assessorId=${this.props.location.state.AssessorID}`
        fetch(fullUrl)
            .then(res => res.json())
            .then((responseJson) => {
                let response = JSON.parse(responseJson);
                if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
                    this.setState({ selectedSkillsProgramme: null, unlinkMessage: response.Message, unlinkMessageStyle: response.MessageType.toLowerCase() });
                    //Force a refresh
                    this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
                }
                else if (!utils.isNull(response.Message) && response.Message !== "") {
                    this.setState({ unlinkMessage: response.Message, unlinkMessageStyle: response.MessageType.toLowerCase() })
                }
            });
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedSkillsProgramme: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedSkillsProgramme: selection[0].Id });
        }
        else {
            this.setState({ selectedSkillsProgramme: null });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={`Assessors > ${this.props.location.state.AssessorName} > Skills Programmes`}>

                <AlertItem message={this.state.unlinkMessage} alertStyle={this.state.unlinkMessageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                    <EnhancedTable
                        headCells={skillsProgrammeHeadCells}
                        dataUrl={`api/indicium/SkillsProgrammeSetup/getAssessorSkillsProgramme`}
                        height="50vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={false} />
                </div>
                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.AssessorName}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Skills Programme to Assessor: ${this.props.location.state.AssessorName}`}
                    linkName={"SkillsProgrammes"} postUrl={"api/indicium/SkillsProgrammeSetup/linkAssessorSkillsProgramme"}
                    selectionId={this.props.location.state.AssessorID}
                >
                    <SkillsProgramSetupSearch
                        dataUrl={"api/indicium/SkillsProgrammeSetup/getAssessorLinkableSkillsProgramme"}
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.AssessorID} programmeType="Q"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkUnitstandard(`api/indicium/SkillsProgrammeSetup/unlinkAssessorSkillsProgramme`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(AssessorSkillsProgrammeSearch)
);
